/**
 * @GENERATED from Figma node 6697:34312
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const SmartsheetDark = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#fff"
      d="M11.918 17.61c2.178-5.033 4.646-9.87 8.024-14.183l.057.02V4.65c0 3.622.007 7.245-.017 10.868-.006 1.008-.1 2.017-.17 3.023a1.8 1.8 0 0 1-.152.56c-.16.386-.403.472-.756.243a3.4 3.4 0 0 1-.649-.56c-.56-.622-.933-1.368-1.296-2.117l-.101-.21q-.28.242-.56.46c-1.307 1.003-2.758 1.758-4.262 2.418-2.54 1.12-5.19 1.85-7.92 2.313a1 1 0 0 1-.116 0c.05-.423.132-.84.14-1.25.027-1.43.035-2.86.036-4.293 0-2.69-.008-5.38-.013-8.069l-.01-5.737V2h15.778c-3.12 2.995-5.796 6.298-7.618 10.275-.044-.079-.078-.134-.106-.187-.436-.87-.9-1.728-1.596-2.42a4.8 4.8 0 0 0-1.003-.74c-.38-.217-.805-.193-1.213-.049-.523.187-1.161.698-1.368 1.102 1.003.112 1.593.807 2.13 1.548.912 1.262 1.52 2.682 2.07 4.128.244.632.455 1.279.69 1.952"
    />
  </svg>
);
const ForwardRef = React.forwardRef(SmartsheetDark);
export { ForwardRef as SmartsheetDark };
